"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGiveUp = exports.GiveUpButton = void 0;
__exportStar(require("./GiveUp"), exports);
var GiveUpButton_1 = require("./GiveUpButton");
Object.defineProperty(exports, "GiveUpButton", { enumerable: true, get: function () { return __importDefault(GiveUpButton_1).default; } });
var useGiveUp_1 = require("./useGiveUp");
Object.defineProperty(exports, "useGiveUp", { enumerable: true, get: function () { return __importDefault(useGiveUp_1).default; } });
